export const home = {
  // Navigation
  'nav.home': 'Accueil',
  'nav.spreadsheet': 'Hub Spreadsheet',
  'nav.safety': 'Guide de Sécurité',
  'nav.about': 'À Propos',
  'nav.contact': 'Contact',
  'nav.categories': 'Catégories',
  'nav.guide': 'Guide d\'Achat',
  'nav.search_placeholder': 'Rechercher des spreadsheets, vendeurs, produits...',

  // Hero
  'hero.title': 'Le Guide Ultime AllChinaBuy Spreadsheet & Achat',
  'hero.subtitle': 'Trouvez de Meilleurs Produits avec le Spreadsheet AllChinaBuy',
  'hero.description': 'Découvrez des spreadsheets AllChinaBuy utiles, des vendeurs, des trouvailles produits, des ressources QC, des informations d\'expédition et des guides d\'achat — organisés en une ressource rapide et facile à utiliser.',
  'hero.cta_primary': 'Explorer le Spreadsheet AllChinaBuy',
  'hero.cta_secondary': 'Parcourir les Guides d\'Achat',
  'hero.trust_badge': 'Ressource indépendante • Mise à jour régulièrement • Conçue pour une recherche produit plus intelligente',
  'hero.supporting': 'Que vous recherchiez un produit spécifique, que vous compariez des vendeurs, que vous vérifiez des informations QC ou que vous recherchiez des coûts d\'expédition, notre hub AllChinaBuy Spreadsheet rassemble les ressources les plus utiles.',

  // Categories
  'categories.title': 'Catégories AllChinaBuy Populaires',
  'categories.description': 'Parcourez nos catégories de produits soigneusement sélectionnées et trouvez exactement ce que vous cherchez.',
  'categories.all': 'Toutes les Catégories',

  // Category names
  'cat.shoes': 'Chaussures',
  'cat.hoodies': 'Sweats / Pulls',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Vestes',
  'cat.pants': 'Pantalons / Shorts',
  'cat.headwear': 'Couvre-Chefs',
  'cat.sets': 'Ensembles',
  'cat.underwear': 'Sous-Vêtements',
  'cat.jersey': 'Maillots',
  'cat.accessories': 'Accessoires',
  'cat.bags': 'Sacs',
  'cat.belts': 'Ceintures',
  'cat.perfumes': 'Parfums',
  'cat.other': 'Autres Articles',

  // Main website CTA buttons
  'cta.main_button': 'Spreadsheet AllChinaBuy',
  'cta.buy_now': 'Achetez Maintenant',
  'cta.visit_main': 'Visiter le Site Principal',
  'cta.ready_title': 'Prêt à Explorer Plus?',
  'cta.ready_desc': 'Utilisez nos ressources AllChinaBuy Spreadsheet pour découvrir des produits, comparer des vendeurs et rechercher votre prochain achat.',

  // Featured Articles
  'articles.title': 'Derniers Guides AllChinaBuy',
  'articles.description': 'Articles approfondis pour vous aider à prendre des décisions d\'achat plus intelligentes.',
  'articles.read_more': 'Lire le Guide Complet',
  'articles.all_guides': 'Voir Tous les Guides',

  // Article titles
  'article.complete_guide': 'AllChinaBuy Spreadsheet: Guide Complet 2026',
  'article.complete_guide_desc': 'Tout ce que vous devez savoir sur l\'utilisation du Spreadsheet AllChinaBuy — de la recherche de vendeurs à la vérification de la qualité produit.',
  'article.is_legit': 'AllChinaBuy est-il Légitime? Guide de Sécurité Complet',
  'article.is_legit_desc': 'Nous analysons la sécurité, les signaux de confiance et les risques d\'achat via AllChinaBuy. Apprenez à vous protéger.',
  'article.shipping': 'Guide des Coûts d\'Expédition AllChinaBuy 2026',
  'article.shipping_desc': 'Détail des méthodes d\'expédition, coûts par pays et conseils pour économiser sur les frais de livraison.',
  'article.coupon': 'Guide des Coupons & Codes de Réduction AllChinaBuy',
  'article.coupon_desc': 'Comment trouver et utiliser les coupons AllChinaBuy, codes de réduction et promotions saisonnières pour des économies maximales.',
  'article.review': 'Avis AllChinaBuy: Fonctionnalités & Expérience d\'Achat',
  'article.review_desc': 'Un avis honnête et indépendant de la plateforme AllChinaBuy couvrant la recherche, la commande, le QC et l\'expédition.',
  'article.qc': 'Guide des Photos QC AllChinaBuy: Ce qu\'il Faut Chercher',
  'article.qc_desc': 'Apprenez à lire les photos QC, repérer les défauts et approuver ou rejeter les articles avant expédition.',
  'article.how_to_use': 'Comment Utiliser le Spreadsheet AllChinaBuy',
  'article.how_to_use_desc': 'Un guide étape par étape de l\'interface du spreadsheet, du parcours des catégories à votre première commande.',
  'article.seller_guide': 'Guide des Vendeurs AllChinaBuy: Trouver des Vendeurs Fiables',
  'article.seller_guide_desc': 'Comment évaluer la réputation, les avis et la communication des vendeurs avant d\'acheter.',
  'article.beginner_guide': 'Guide Débutant AllChinaBuy: Commencez en Confiance',
  'article.beginner_guide_desc': 'Une introduction complète pour les premiers acheteurs couvrant comptes, commandes, QC et expédition.',
  'article.best_finds': 'Meilleures Trouvailles AllChinaBuy: Produits à Acheter',
  'article.best_finds_desc': 'Nos sélections de chaussures, vêtements, sacs et accessoires tendance à découvrir.',
  'article.warehouse': 'Guide de l\'Entrepôt AllChinaBuy: Stockage, QC & Expédition',
  'article.warehouse_desc': 'Comprendre comment l\'entrepôt stocke, inspecte et regroupe vos commandes avant expédition.',
  'article.alternatives': 'Alternatives à AllChinaBuy: Plateformes Comparées',
  'article.alternatives_desc': 'Une comparaison équilibrée d\'AllChinaBuy et d\'autres plateformes d\'agent shopping.',
  'article.payment': 'Guide de Paiement & Remboursement AllChinaBuy',
  'article.payment_desc': 'Méthodes de paiement, politiques de remboursement et résolution des problèmes de commande.',
  'article.tracking': 'Guide de Suivi AllChinaBuy: Suivez Votre Commande',
  'article.tracking_desc': 'Comment suivre votre colis de l\'entrepôt à votre porte avec des conseils utiles.',
  'article.qc_checklist': 'Checklist QC AllChinaBuy: Vérifiez Avant l\'Expédition',
  'article.qc_checklist_desc': 'Une checklist imprimable de ce qu\'il faut vérifier dans les photos QC avant d\'approuver l\'expédition.',
  'article.best_sellers': 'Meilleurs Vendeurs AllChinaBuy 2026: Boutiques Fiables',
  'article.best_sellers_desc': 'Les vendeurs avec la meilleure réputation dans les catégories populaires.',

  // Trust section
  'trust.title': 'AllChinaBuy est-il Sûr à Utiliser?',
  'trust.subtitle': 'Notre évaluation de sécurité indépendante',
  'trust.desc': 'Nous avons analysé la plateforme AllChinaBuy de manière indépendante. Ce site n\'est pas affilié à AllChinaBuy. Nous fournissons des informations honnêtes basées sur la recherche pour vous aider à prendre des décisions éclairées.',
  'trust.checklist_title': 'Liste de Vérification de Sécurité Avant Achat',
  'trust.check_1': 'Vérifier la réputation et les avis des vendeurs',
  'trust.check_2': 'Vérifier les photos QC avant d\'approuver l\'expédition',
  'trust.check_3': 'Utiliser des méthodes de paiement sécurisées',
  'trust.check_4': 'Comparer les coûts et méthodes d\'expédition',
  'trust.check_5': 'Lire les expériences récentes des acheteurs',
  'trust.read_more': 'Lire le Guide de Sécurité Complet',

  // FAQ
  'faq.title': 'Questions Fréquemment Posées',
  'faq.q1': 'Qu\'est-ce que le Spreadsheet AllChinaBuy?',
  'faq.a1': 'Le Spreadsheet AllChinaBuy est une collection organisée de liens produits, d\'informations vendeur et de ressources d\'achat qui aide les acheteurs à trouver des produits de qualité via la plateforme AllChinaBuy. Il organise les produits par catégorie avec liens, prix et évaluations vendeur.',
  'faq.q2': 'Comment utiliser le Spreadsheet AllChinaBuy?',
  'faq.a2': 'Parcourez simplement les catégories qui vous intéressent, cliquez sur les liens produits pour voir les détails sur la plateforme AllChinaBuy, et suivez les guides d\'achat pour une expérience d\'achat fluide. Nous recommandons de commencer par notre Guide Complet pour débutants.',
  'faq.q3': 'AllChinaBuy est-il légitime?',
  'faq.a3': 'AllChinaBuy est une plateforme d\'agent shopping connue. Comme tout marketplace en ligne, les expériences d\'acheteurs varient. Nous recommandons de lire notre guide de sécurité indépendant, vérifier les avis vendeur et toujours utiliser les photos QC avant d\'approuver les expéditions.',
  'faq.q4': 'Combien coûte l\'expédition AllChinaBuy?',
  'faq.a4': 'Les coûts d\'expédition varient selon la destination, le poids et la méthode d\'expédition. Notre guide des coûts d\'expédition fournit des estimations détaillées pour les USA, UK, Allemagne, France, Danemark et autres pays.',
  'faq.q5': 'AllChinaBuy propose-t-il des coupons?',
  'faq.a5': 'AllChinaBuy propose occasionnellement des coupons et codes de réduction. Consultez notre guide des coupons pour les dernières offres et conseils pour maximiser vos économies.',

  // Footer
  'footer.about_title': 'À Propos de ce Site',
  'footer.about_desc': 'AllChinaBuySpread est un hub de ressources indépendant. Nous ne sommes pas officiellement affiliés à AllChinaBuy. Toutes les informations sont à des fins de recherche et d\'éducation uniquement.',
  'footer.links_title': 'Liens Rapides',
  'footer.link_safety': 'Guide de Sécurité',
  'footer.link_about': 'À Propos',
  'footer.link_contact': 'Contact',
  'footer.link_disclaimer': 'Avertissement',
  'footer.legal': 'Ceci est un site de ressources indépendant. Les liens produits redirigent vers AllChinaBuy et kaspreadsheet.com.',
  'footer.copyright': '© 2026 AllChinaBuySpread. Tous droits réservés.',

  // Common
  'common.loading': 'Chargement...',
  'common.read_time': 'min de lecture',
  'common.updated': 'Mis à jour',
  'common.independent': 'Ressource Indépendante',
};